import { calculateAudioDuration } from '@/utils/audioDuration';

// 音频时长
export function getAudioDuration(url) {
  return calculateAudioDuration(url);
}

// 一个文字的播放时长毫秒单位
export const avgDuration = 315;

export function calculateSSMLDuration(ssmlHtml, averageCharDuration = avgDuration) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(ssmlHtml, 'text/xml');

  // 存放设计过的时长
  let customTimesArr: any = [];

  // 存放纯文本
  let textContent = '';
  const breakOptions = [
    { value: 'weak', label: '短', time: '400ms' },
    { value: 'medium', label: '中', time: '800ms' },
    { value: 'strong', label: '长', time: '1000ms' },
  ];

  // 纯文本汇总 抽离break
  xmlDoc.documentElement.childNodes.forEach((node: any) => {
    // break停顿静音
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'break') {
      const strength = node?.getAttribute('strength');
      const time = node?.getAttribute('time');
      if (strength || time) {
        if (!time && strength) {
          let { time } = breakOptions.find((v) => v.value === strength) as any;
          customTimesArr.push({ strength, time });
        } else {
          customTimesArr.push({ strength, time });
        }
      }
    }

    // prosody局部变速
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'prosody') {
      const rate = node?.getAttribute('rate');

      if (rate && rate !== '0%') {
        customTimesArr.push({
          textContent: node.textContent,
          time: `${calculateDuration({ text: node.textContent, rate, averageCharDuration })}ms`,
          averageCharDuration,
        });
      } else {
        textContent += node.textContent;
      }
    }

    // 别名
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'sub') {
      const alias = node?.getAttribute('alias');
      textContent += alias;
    } else {
      textContent += node.textContent;
    }
  });

  //  纯文本时长 毫秒
  let allDuration = estimateSpeechDuration(textContent) + calculateTotalCustomTimes(customTimesArr);
  return millisecondsToSeconds(allDuration);
}

// 毫秒转秒
export function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1000;
}

// 局部变速获取内容时长
export function calculateDuration({ text, rate, averageCharDuration }) {
  const totalChars = text.length;

  // 移除百分号并转换为数字
  const rateNum = Number(rate.replace('%', ''));

  // 根据正负数确定实际速率
  let actualRate;
  if (rateNum > 0) {
    // 对于正数，rateNum/100 是相对于正常速度的倍数
    actualRate = rateNum / 100;
  } else {
    // 对于负数，100 + rateNum 是相对于正常速度的百分比，取倒数得到速率
    actualRate = 100 / (100 + rateNum);
  }

  // 确保速率不会导致除以零或其他错误
  actualRate = Math.max(0.001, actualRate);

  // 计算每个字符的实际时长
  const durationPerChar = averageCharDuration / actualRate;

  // 计算总时长
  const totalDuration = durationPerChar * totalChars;

  return totalDuration;
}

// 计算纯文本时长
export function estimateSpeechDuration(text, averageCharDuration = avgDuration) {
  // 使用正则表达式匹配所有的中文字符
  const chineseChars = text.match(/[\u4e00-\u9fff]/g) || [];

  // 计算中文字符的总时长
  let duration = chineseChars.length * averageCharDuration;

  // 添加额外的处理，比如对于空格、标点符号或者其他非中文字符的处理
  // 这里简单处理，假设非中文字符和空格不增加额外的时长
  // 实际应用中，你可能需要根据实际情况调整这些假设
  return duration;
}

// 计算设计过的时长
export function calculateTotalCustomTimes(breaks) {
  let totalTime = 0;
  breaks.forEach((breakItem) => {
    const timeStr = breakItem.time;
    if (timeStr) {
      const match = timeStr.match(/(\d+(\.\d+)?)(ms)?/);
      if (match) {
        const timeValue = parseInt(match[1], 10);
        totalTime += timeValue;
      } else {
        totalTime += 0;
      }
    }
  });
  return totalTime;
}
